import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    base: '/wp-json/wp/v2/',
    info: {},
    pages: [],
    start: {},
    projects: [],
    slides: [],
    team: []
  },
  mutations: {
    saveInfo(state,data) {
      state.info = data;
    },
    savePages(state,data) {
      state.pages = data;
    },
    saveStart(state,data) {

      state.start = data.filter(d => d.slug==='start')[0];
    },
    saveTeam(state,data) {
      state.team = data
    },
    saveSlides(state,data) {
      let start = data.filter(d => d.slug==='start')[0];
      state.slides = start.acf.element
    },
    saveProjects(state,data) {
      state.projects = data
    },

  },
  actions: {
    getInfo(store) {
      Axios.get(store.state.base).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveInfo', response.data);
      });
    },
    getPages(store) {
      Axios.get(store.state.base + 'pages?_embed').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('savePages', response.data);
        store.commit('saveStart', response.data);
        store.commit('saveSlides', response.data);
      });
    },
    getProjects(store) {
      Axios.get(store.state.base + 'projekte?_embed&orderby=menu_order&order=asc').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveProjects', response.data);
      });
    },
    getTeam(store) {
      Axios.get(store.state.base + 'team?_embed').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveTeam', response.data);
      });

    },
  },
  modules: {
  }
})
